import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledFile = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'onClick',
})<{ onClick?: VoidFunction }>(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
  borderRadius: '12px',
  filter: theme.customShadows.filter,
  width: '96px',
  border: '1px solid',
  borderColor: theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
  height: '96px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  ':hover': {
    cursor: 'pointer',
    backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
  },
}));
